import { createFileRoute } from '@tanstack/react-router'
import { InterventionPage } from '../../../components/InterventionPage'

export const Route = createFileRoute('/$org/interventions/$interventionUid')({
  component: InterventionDetail,
})

function InterventionDetail() {
  return <InterventionPage />
}
